"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPage = exports.pageOf = exports.emptyPage = void 0;
/**
 * Represents an empty Page useful for initializing variables while
 * waiting for the actual Page to be retrieved.
 */
function emptyPage() {
    return Object.freeze({
        content: [],
        last: true,
        totalElements: 0,
        totalPages: 0,
        size: 0,
        number: 0,
        first: true,
        numberOfElements: 0
    });
}
exports.emptyPage = emptyPage;
/**
 * Create a Page of a subset of an array of items.
 */
function pageOf(content, page = 1, size = 10, oneBased = true) {
    const actualPage = oneBased ? page - 1 : page;
    const offset = actualPage * size;
    const slice = content.slice(offset, offset + size);
    const totalPages = Math.max(1, Math.ceil(content.length / size));
    return Object.freeze({
        content: slice,
        last: oneBased ? page === totalPages : page === totalPages - 1,
        totalElements: content.length,
        totalPages,
        size: slice.length,
        number: page,
        first: oneBased ? page === 1 : page === 0,
        numberOfElements: slice.length
    });
}
exports.pageOf = pageOf;
/**
 * Map a page returned from the back-end to a page of a specific type.
 *
 * @param mapper Function to map the items to a specific type
 */
function mapPage(mapper) {
    return (page) => Object.freeze(Object.assign(Object.assign({}, page), { content: page.content.map(mapper) }));
}
exports.mapPage = mapPage;
